import { render, staticRenderFns } from "./CheckboxComponent.vue?vue&type=template&id=65a1fc53"
import script from "./CheckboxComponent.vue?vue&type=script&lang=js"
export * from "./CheckboxComponent.vue?vue&type=script&lang=js"
import style0 from "./CheckboxComponent.vue?vue&type=style&index=0&id=65a1fc53&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports